var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "banner" },
    [
      _c("p", { staticClass: "banner-text" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.addDotsInNumber(_vm.houseCountVariable)) +
            " " +
            _vm._s(
              true === _vm.showRentalType
                ? _vm.rentalTypeName()
                : _vm.resultsName(_vm.houseCountVariable)
            ) +
            "  " +
            _vm._s(true === _vm.showCityName ? " in " + _vm.location : "") +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("adivare-login-house-count-text"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }